import { Injectable } from "@angular/core";

// import { GraphQLResult, generateClient } from 'aws-amplify/api';

// import { graphqlOperation } from '@aws-amplify/api-graphql';
import { RncUsersModel, cpRnUserModel } from "../../model/user.model";
import {
  checkUserAccessControlQueries,
  cpUserAccessControlQueries,
  createUACQueries,
  filterByUserType,
  findUserQueries,
  updateUACQueries,
} from "../../graphql/user.queries";
import { AppConstants } from "./app-constants";
import { environment } from "../../../../../../environments/environment";

//const client = generateClient();

import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";
import { HttpClient } from "@angular/common/http";
import { TableConstants } from "../../../../../constants/table-constants";
import { HttpUtilsService } from "../../../../../service/httputils.service";
let url = environment.pg_dburl[window.location.origin];

let myAppConfig = environment.myAppConfig;

Amplify.configure(myAppConfig);

//createOrUpdateCpRnUser
@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(private httpUtils: HttpUtilsService) {}
  private QUERY_KEY = {
    create_user: `${AppConstants.create}${environment.dbPrefix}${AppConstants.createOrUpdateRncUsers}`,
    list_user: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listRncUsers}`,

    createcpAssignedRNUser: `${AppConstants.create}${environment.dbPrefix}${AppConstants.createCpRnUser}`,
    updatecpAssignedRNUser: `${AppConstants.update}${environment.dbPrefix}${AppConstants.UpdateCpRnUser}`,
    list_cpAssignedRNUser: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpRnUser}`,
  };
  /*****************************************************************************
   * RN USER - USER ACCESS CONTROL
   ****************************************************************************/
  public async filterByUser(userName?: string): Promise<RncUsersModel[]> {
    const tablename = TableConstants.RncUsers;
    let endpoint = `${url}/${tablename}`;
    if (userName) {
      endpoint += `?data->>user_name=eq.${userName}`;
    }
    try {
      const response = await this.httpUtils.get<RncUsersModel[]>(endpoint);
      if (response) {
        console.log("USER_RESPONSE:", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      throw error;
    }
  }

  public async filterByUserType(
    offset: number = 0,
    limit: number = 100,
    userType?: any
  ): Promise<RncUsersModel[]> {
    const tablename = TableConstants.RncUsers;
    let endpoint = `${url}/${tablename}?data->>user_type=eq.${userType}`;
    try {
      const response = await this.httpUtils.get<RncUsersModel[]>(endpoint);
      if (response) {
        console.log("USER_RESPONSE:", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching user by type:", error);
      throw error;
    }
  }

  /*****************************************************************************
   * CAP ASSIST - USER ACCESS CONTROL
   ****************************************************************************/
  public async cpUserAccessControlList(): Promise<cpRnUserModel[]> {
    const tablename = TableConstants.CpRnUser;
    const endpoint = `${url}/${tablename}`;
    try {
      const response = await this.httpUtils.get<cpRnUserModel[]>(endpoint);
      if (response) {
        console.log("[CP_USER_ACCESS_CONTROL_LIST_RESPONSE]", response);
        return response;
      } else {
        throw new Error(
          "REST operation returned no data cap assists assigned rnuser."
        );
      }
    } catch (error) {
      console.error("Error fetching CapAssist RNuser request status:", error);
      throw error;
    }
  }

  public async checkUserAccessControlByUser(
    userId: any
  ): Promise<cpRnUserModel[]> {
    const tablename = TableConstants.CpRnUser;
    const endpoint = `${url}/${tablename}?data->>user_name=eq.${userId}`;
    try {
      const response = await this.httpUtils.get<cpRnUserModel[]>(endpoint);
      if (response) {
        console.log("[CP_USER_ACCESS_CONTROL_BY_USER_RESPONSE]", response);
        return response;
      } else {
        throw new Error(
          "REST operation returned no data for cap assists check rnuser."
        );
      }
    } catch (error) {
      console.error("Error fetching cap assists check rnuser status:", error);
      throw error;
    }
  }

  public async createUserAccessControl(
    createdObj: any
  ): Promise<cpRnUserModel | null> {
    const tablename = TableConstants.CpRnUser;
    const endpoint = `${url}/${tablename}?select=*`;
    const payload = {
      data: {
        user_name: createdObj.user_name,
        name: createdObj.name,
        email: createdObj.email,
        phone: createdObj.phone,
        assign_mode: createdObj.assign_mode,
        status: createdObj.status,
        ex_data: createdObj.ex_data,
        created_date: AppConstants.getlocalDateFormate(),
        updated_date: AppConstants.getlocalDateFormate(),
      },
      created_date: AppConstants.getlocalDateFormate(),
      updated_date: AppConstants.getlocalDateFormate(),
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error creating user access control:", error);
      throw error;
    }
  }

  public async updateUserAccessControl(
    updateObj: any
  ): Promise<cpRnUserModel | null> {
    const functionName = TableConstants.fnUpdateCpRnUserdata;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateObj.id,
      updates: {
        user_name: updateObj.user_name,
        name: updateObj.name,
        email: updateObj.email,
        phone: updateObj.phone,
        assign_mode: updateObj.assign_mode,
        status: updateObj.status,
        ex_data: updateObj.ex_data,
        updated_date: AppConstants.getlocalDateFormate(),
      },
      p_updated_date: AppConstants.getlocalDateFormate(),
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error updating user access control:", error);
      throw error;
    }
  }
}
